import UpperFunnelTile from 'components/Catalog/UpperFunnel/UpperFunnelProductTiles/UpperFunnelTile/UpperFunnelTile';

export default UpperFunnelTile;
